var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { omit } from "lodash";
class ImagePluginService {
  createLoadingData(_, url, componentData) {
    return {
      componentData: __spreadValues({}, componentData),
      componentState: {
        tempData: url,
        loading: true
      }
    };
  }
  createPluginData(uploadedData, componentData) {
    const { file_name, width, height } = uploadedData.data || {};
    return __spreadProps(__spreadValues({}, omit(componentData, ["tempData", "loading"])), {
      image: { src: { id: file_name }, width, height }
    });
  }
  createErrorData(error, componentData) {
    return __spreadProps(__spreadValues({}, omit(componentData, ["loading"])), {
      error
    });
  }
}
export {
  ImagePluginService
};
//# sourceMappingURL=imagePluginService.js.map
